import { render, staticRenderFns } from "./PuzzleVerification.vue?vue&type=template&id=a48dadfe&scoped=true&"
import script from "./PuzzleVerification.vue?vue&type=script&lang=js&"
export * from "./PuzzleVerification.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleVerification.vue?vue&type=style&index=0&id=a48dadfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48dadfe",
  null
  
)

export default component.exports